module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_micro-e8eec962b2a49214ba608e31e57c7af3.png";